export const STORAGE_KEY = "cookieSettings";

export const hasMapPermission = (): boolean => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return !!saved && !!JSON.parse(saved)?.maps;
  } catch {
    return false;
  }
};
